import { useQuery } from '@tanstack/react-query'
import { getMeetingContentSections } from '../api/meetingApi'

/**
 * İçerik bölümü tanımları (aktif REF_MEETING_DECISION_TYPE, SORT_INDEX ASC). Tutanak Oluştur/Detay/Düzenleme
 * içerik listelerinin başlık + sırası bundan gelir. Nadiren değişen referans → uzun staleTime.
 */
export function useMeetingContentSections() {
  return useQuery({
    queryKey: ['meeting-content-sections'],
    queryFn: getMeetingContentSections,
    staleTime: 5 * 60 * 1000,
  })
}
